<div class="search_mobile_open">
  <div class="content">
    <div class="offers_filter_tags" *ngIf="tagsSelected.length">
      <ng-container *ngFor="let t of tagsSelected">
        <span class="tag" (click)="removeTag(t)" [style.background-color]="getValueColorTag(t)">
          <fa-icon [icon]="getFaIcon('faTimesCircle')"></fa-icon>
          {{t.tagName}}
        </span>
      </ng-container>
    </div>
    <div class="section_universe">
      <h2>Centre d'intérêt</h2>
      <form [formGroup]="searchForm">
        <div class="search-filter">
          <input type="text" matInput formControlName="search"  placeholder="Recherche"/>
        </div>
        <mat-error *ngIf="searchForm.get('search').value && searchForm.get('search').value.length < 3">
          <span>Veuillez insérer au moins 3 caractères</span>
        </mat-error>

        <ng-container *ngIf="universeSelected === 5">
          <div class="offers_filter_search">
            <div appearance="outline" class="city">
              <input matInput ngx-google-places-autocomplete (onAddressChange)="getAddressSearch($event)" type="text"
                formControlName="keyword" placeholder="Choix de la ville...">
                <fa-icon [icon]="valueInput ? getFaIcon('faTimes') : getFaIcon('faSearch')"
                (click)="valueInput ? resetSearch(): null"></fa-icon>
            </div>
            <div class="slider">
              <span *ngIf="valueKM < 205">Distance : <b>{{ valueKM }} km</b></span>
              <span *ngIf="valueKM === 205">Distance : <b>Toutes</b></span>
              <mat-slider formControlName="slider" min="10" max="205" step="5" [value]="valueKM" (change)="getValueKM($event)" showTickMarks discrete>
                <input matSliderThumb>
              </mat-slider>
            </div>
            <mat-form-field appearance="outline" class="startdate">
              <mat-label>Date de début</mat-label>
              <input matInput [matDatepicker]="datePicker" formControlName="startDate">
              <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
              <mat-datepicker #datePicker disabled="false"></mat-datepicker>
            </mat-form-field>
          </div>
        </ng-container>
      </form>
      <ng-container *ngIf="!isLoading; else elseTemplate">
        <mat-radio-group [color]="color" aria-label="Select an option" class="univers_radio_button">
          <ng-container *ngFor="let universe of listUniverses">
            <div class="label_radio_button">
              <mat-radio-button (click)="goToUniverseWithQueryParam(universe.universeKey)" [checked]="universIsSelected(universe.universeKey)" value="{{universe.universeKey}}">
                <span class="radioLabel">{{ universe.universeName }}</span>
              </mat-radio-button>
            </div>
          </ng-container>
        </mat-radio-group>
      </ng-container>

      <ng-template #elseTemplate>
        <div class="loader">
          <mat-spinner [diameter]="50"></mat-spinner>
        </div>
      </ng-template>

      <!-- <mat-radio-group [color]="color" aria-label="Select an option" class="univers_radio_button">
        <div class="label_radio_button">
          <mat-radio-button (click)="goToUniverseWithQueryParam(1)" [checked]="universIsSelected(1)" value="1">
            <span class="radioLabel">
              Loisirs et Découvertes
            </span>
          </mat-radio-button>
        </div>

        <div class="label_radio_button">
          <mat-radio-button (click)="goToUniverseWithQueryParam(2)" [checked]="universIsSelected(2)" value="2">
            <span class="radioLabel">
              Compétitions
            </span>
          </mat-radio-button>
        </div>

        <div class="label_radio_button">
          <mat-radio-button (click)="goToUniverseWithQueryParam(3)" [checked]="universIsSelected(3)" value="3">
            <span class="radioLabel">
              Formations Professionnelles
            </span>
          </mat-radio-button>
        </div>

        <div class="label_radio_button">
          <mat-radio-button (click)="goToUniverseWithQueryParam(4)" [checked]="universIsSelected(4)" value="4">
            <span class="radioLabel">
              Entreprises
            </span>
          </mat-radio-button>
        </div>

        <div class="label_radio_button">
          <mat-radio-button (click)="goToUniverseWithQueryParam(6)" [checked]="universIsSelected(6)" value="6">
            <span class="radioLabel">
              Apprendre et se perfectionner
            </span>
          </mat-radio-button>
        </div>
      </mat-radio-group> -->
    </div>

    <div class="offers_filter_tags_more" id="tags">
      <ng-container *ngFor="let t of tags">
        <span *ngIf="isInTagSelected(t?.tagName)" class="tag" (click)="addTag(t)"
          [style.background-color]="getValueColorTag(t)"> {{t.tagName}} </span>
      </ng-container>

    </div>
  </div>

  <div class="search_container">
    <!-- <form [formGroup]="searchForm" class="search_bar">
      <input ngx-google-places-autocomplete (onAddressChange)="getAddressSearch($event)" type="text"
        formControlName="keyword" placeholder="Choix de la ville...">
      <fa-icon [icon]="valueInput ? getFaIcon('faTimes') :  getFaIcon('faSearch')"
        (click)="valueInput ? resetSearch(): null"></fa-icon>
    </form> -->
    <div class="validate" (click)="getAddressSearch(null, true)" appChangeColorTheme attribute="bgc">
      <fa-icon [icon]="getFaIcon('faCheck')"></fa-icon>
      <p>Confirmer</p>
    </div>
  </div>

  <!-- <fa-icon [ngClass]="{close: openSearch}" [icon]="!openSearch?  faSearch : faCheck" (click)="openDivSearch()"></fa-icon> -->
</div>
